/* eslint-disable @typescript-eslint/no-explicit-any */
import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Benefits } from '../models/benefts.interface';
import { ActivatedRoute, Router } from '@angular/router';
import { PaginatorComponent } from 'src/app/components/paginator/paginator.component';
import { CommmonService } from 'src/app/utils/common.service';
import { EmployeeService } from 'src/app/home/services/employee.service';
import { PageStateService } from 'src/app/components/paginator/page-state.service';


@Component({
  selector: 'app-benefits',
  templateUrl: './benefits.component.html',
  styleUrls: ['./benefits.component.scss'],
})
export class BenefitsComponent implements OnInit {
  @ViewChild(PaginatorComponent, { static: false }) childC!: PaginatorComponent;

  isSizeMobile = false;
  showFilterMobile = false;
  benefits!: Benefits[];
  searchTerm = '';
  currentPage = 1;
  totalPages!: number;
  totalRows!: number;
  paginatedCards!: Benefits[];
  selectedSortOption = 'order';
  itemsPerPage = 15;
  isFilter = false;
  dataFilterSaved: any;
  isPracticing: any;
  user_plan:any;
  filteredResults!:Benefits[];
  activeFilters = {
  category: -1,
  antiquity: [] as number[],
  plan: [] as number[],
  beneficiaryType: [] as number[]
};

  constructor(
    private breakpointObserver: BreakpointObserver,
    private router: Router,
    private common_service: CommmonService,
    private employee_service: EmployeeService,
    private pageStateService: PageStateService,
    private route: ActivatedRoute,
  ) {}

  async ngOnInit(){
    this.user_plan = this.route.snapshot.data['resolve_user_plan'] ?? [];   
    const activeUser = JSON.parse(
      this.common_service.getItemSessionStorage('id_token_claims_obj') ?? '{}',
    );
    if (activeUser) {
      const employee_plan = await this.employee_service.get_employee_plan();
      const userIsPracticing = employee_plan.description_plan;
      if (userIsPracticing === 'Practicantes') {
        this.isPracticing = true;
      } else {
        this.isPracticing = false;
      }
    }

    this.activeFilters.category = this.pageStateService.selected_category ?? -1;
    this.activeFilters.antiquity = this.pageStateService.filterAntiquesIdChecked ?? [];
    this.activeFilters.plan = this.pageStateService.filterplanIdchecked ?? [];
    this.activeFilters.beneficiaryType = this.pageStateService.filterTypeidChecked ?? [];
    this.filterBenefits({ type: 'init' });

    this.isFilter = this.pageStateService.isFilter;
    this.currentPage = this.pageStateService.currentPage;
    this.getBenefits();
    this.memoryFilter();
    this.memorySearcher();

    const oritentation = this.breakpointObserver.observe([
      '(max-width: 768px)',
    ]);
    oritentation.subscribe((lay) => {
      this.isSizeMobile = lay.breakpoints['(max-width: 768px)'];
    });
  }


  async getBenefits() {
    this.common_service.removeItemLocalStorage('benefits');
    this.benefits = this.common_service.sortArray(
      this.route.snapshot.data['resolverBenefit'] ?? [],
    );
    
    if (this.isPracticing) {
      this.benefits.sort((a, b) => {
        const aHasPlan5 = a.plans.includes(5);
        const bHasPlan5 = b.plans.includes(5);

        if (aHasPlan5 && !bHasPlan5) {
          return -1;
        } else if (!aHasPlan5 && bHasPlan5) {
          return 1;
        }
        return 0;
      });
    }
    this.quitarBeneficios(this.benefits)

    // Sobrescribir títulos de beneficios con nombre distinto en frontend
    this.benefits = this.benefits.map((b: any) =>
      b.id === 23 ? { ...b, title: 'Bono Vacaciones' } : b
    );

    this.common_service.setItemLocalStorage(
      'benefits',
      JSON.stringify(this.benefits),
    );
    this.totalPages = Math.ceil(this.benefits.length / this.itemsPerPage);
    this.totalRows = this.benefits.length;

    this.paginateCards(this.currentPage, this.benefits);
  }


  quitarBeneficios(benefit:any){
    const cambioPlan = benefit.find((objeto:any) => objeto.title === 'Cambio de Plan');
    if (cambioPlan) {
      const index = benefit.indexOf(cambioPlan);
      if (index > -1) {
        benefit.splice(index, 1); 
      }
    }

    if(this.user_plan.plan_id !== 5 ){ 
      const jubilado = benefit.filter((objeto:any )=> objeto.plans[0]=== 5);
        if (jubilado) {
          jubilado.forEach((jubi: any) => {
            const index = benefit.indexOf(jubi);
            if (index > -1) {
              benefit.splice(index, 1);}})
        }
    }  
  }


  onPageChange(page: number) {
    window.scrollTo(0, 0);
    this.currentPage = page;
    this.pageStateService.currentPage = this.currentPage;
    this.paginateCards(page, this.benefits);
  }

  paginateCards(page: number, benefits: Benefits[]) {
    this.currentPage = page;
    this.paginatedCards = benefits.slice(
      (page - 1) * this.itemsPerPage,
      page * this.itemsPerPage,
    );
  }


filterBenefits(data: any) {
  const rawBenefits = JSON.parse(
    this.common_service.getItemLocalStorage('benefits') ?? '[]'
  );

  const previousCategory = this.activeFilters.category;
  const previousPlans = [...this.activeFilters.plan];
  const previousAntiquities = [...this.activeFilters.antiquity];
  const previousTypes = [...this.activeFilters.beneficiaryType];

  
  if (data.type === 'category') {
    this.activeFilters.category = data.idcategory ?? data.id;
  } else if (data.type !== 'init') {
    this.activeFilters[data.type as 'antiquity' | 'plan' | 'beneficiaryType'] = data.values ?? [];
  }

  this.filteredResults = [...rawBenefits];

  this.categoryFilter(previousCategory);
  this.antiquityFilter(previousAntiquities);
  this.planFilter(previousPlans);
  this.typeBenefitFilter(previousTypes);


  this.benefits = this.filteredResults;
  this.totalPages = Math.ceil(this.benefits.length / this.itemsPerPage);
 
  this.currentPage = this.pageStateService.currentPage ?? 1;

  this.paginateCards(this.currentPage, this.benefits);
  
  this.savedStateService(data)
  this.validationFilter()

  this.childC?.getNumberPagesPaginator(this.currentPage, this.totalPages);
} 

  categoryFilter(previousCategory:any){
     if (this.activeFilters.category !== -1) {
    this.filteredResults = this.filteredResults.filter((benefit: any) =>
      benefit.categories?.includes(this.activeFilters.category)
    );
    if(this.activeFilters.category !== previousCategory){
      this.resetCurrenPage()
    }
    }
  }

  antiquityFilter(previousAntiquities:any){ 
    if(this.activeFilters.antiquity.length > 0) {
      this.filteredResults = this.filteredResults.filter((benefit: any) =>
        this.activeFilters.antiquity.some((id: number) => 
          benefit.antiques?.includes(id)
        )); 
      if(JSON.stringify(this.activeFilters.antiquity) !== JSON.stringify(previousAntiquities)){
        this.resetCurrenPage()
    }}}

  planFilter(previousPlans:any){
    if (this.activeFilters.plan.length > 0) {
      this.filteredResults = this.filteredResults.filter((benefit: any) =>
        this.activeFilters.plan.some((id: number) => benefit.plans?.includes(id))
      );
      if(JSON.stringify(this.activeFilters.plan) !== JSON.stringify(previousPlans)){
      this.resetCurrenPage()
      }
    }
    }

  typeBenefitFilter(previousTypes:any){
    if (this.activeFilters.beneficiaryType.length > 0) {
      this.filteredResults = this.filteredResults.filter((benefit: any) =>
        this.activeFilters.beneficiaryType.some((id: number) => benefit.beneficiaryTypes?.includes(id))
      );
      if(JSON.stringify(this.activeFilters.beneficiaryType) !== JSON.stringify(previousTypes)){
      this.resetCurrenPage()}
    }}

  savedStateService(data:any){
    if (data.type !== 'init') {
    this.pageStateService.filternewDataBenefits = data;
    }
  }

 validationFilter(){
   this.pageStateService.isFilter = (
    this.activeFilters.category !== -1 ||
    this.activeFilters.antiquity.length > 0 ||
    this.activeFilters.plan.length > 0 ||
    this.activeFilters.beneficiaryType.length > 0
  );
 }

  onSearch() {
    this.benefits = JSON.parse(
      this.common_service.getItemLocalStorage('benefits') ?? '[]',
    );
    if (this.searchTerm.length >= 3) {
      this.paginatedCards = this.benefits.filter(
        (benefit) =>
          benefit.title
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .includes(this.searchTerm.toLowerCase()) ||
          benefit.title.toLowerCase().includes(this.searchTerm.toLowerCase()),
      );
      this.pageStateService.searchName = this.searchTerm;
      this.pageStateService.searchActive = true;
      this.totalPages = Math.ceil(
        this.paginatedCards.length / this.itemsPerPage,
      );
      this.paginateCards(1, this.paginatedCards);
      if (this.paginatedCards.length === 0) {
        this.paginateCards(1, this.paginatedCards);
      }
    } else {
      this.totalPages = Math.ceil(this.benefits.length / this.itemsPerPage);
      this.paginateCards(1, this.benefits);
      this.pageStateService.searchName = this.searchTerm;
      this.pageStateService.searchActive = false;
    }
    this.childC?.getNumberPagesPaginator(this.currentPage, this.totalPages);
  }

  showModalFilter() {
    this.showFilterMobile = true;
  }

  getStatusModalFilter(status: boolean) {
    this.showFilterMobile = status;
  }

  goToBenefit() {
    window.scrollTo(0, 0);
    this.router.navigate(['/benefits']);
  }

 
  resetCurrenPage() {
    this.currentPage = 1;
    this.pageStateService.currentPage = 1;
    window.scrollTo({top:400, behavior:'smooth'});
  }

  memorySearcher() {
    if (
      this.pageStateService.searchActive &&
      this.pageStateService.searchName.length !== 0
    ) {
      this.searchTerm = this.pageStateService.searchName;
      this.onSearch();
    }
  }

  memoryFilter() {
    if (this.isFilter) {
      this.dataFilterSaved = this.pageStateService.filternewDataBenefits;
      this.filterBenefits(this.dataFilterSaved);
    }
  }
}
